module.exports = __webpack_public_path__ + "img/mesa_ls01a.3e07f319.png";